<template>
  <div
    class="content"
    :class="{'cover':!$store.getters.ambientType}"
  >
    <div class="settle flex-between">
      <div class="settle-price">
        未到账金额:<span style="color: #FF1310">￥{{price}}</span>
      </div>
      <router-link
        tag="div"
        to="/beSettledRule"
      >规则说明</router-link>
    </div>
    <van-list
      v-model="isUpLoading"
      :finished="finished"
      :finished-text="!orderList.length?'':'没有更多了'"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="tobeSettled"
      class="order-box"
    >
      <div
        class="order-info"
        v-for="(item,index) in orderList"
        :key="index"
      >
        <div class="info-common flex-between">
          <span>下单时间:</span>
          <span>{{item.createTime}}</span>
        </div>
        <div class="info-common flex-between">
          <span>订单编号:</span>
          <span>{{item.orderSn}}</span>
        </div>
        <div class="info-common flex-between">
          <span>佣金:</span>
          <span style="color: #FF1310;font-weight: 800;">￥{{item.money}}</span>
        </div>
      </div>
      <div
        class="notHave"
        v-show="!orderList.length&&!isUpLoading&&!error"
      >
        <i class="iconfont icon-personal_image_nosto1"></i>
        <p>暂时没有记录哦</p>
      </div>
    </van-list>
  </div>
</template>

<script>
import { tobeSettled } from "@/api/join";
export default {
  data() {
    return {
      orderList: [],
      isUpLoading: false,
      finished: false,
      error: false,
      pageIndex: 1,
      price: this.GetQueryString("price")
    };
  },
  methods: {
    tobeSettled() {
      tobeSettled({
        page: {
          way: "1", // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pageIndex, // 请求页数，index = 1 表示第一页
          size: "20", //数量
        },
      })
        .then((res) => {
          if (res.appStatus.errorCode == 0) {
            const list = res.content.list;
            if (list.length < 20) {
              // 最后一页不足10条的情况
              this.finished = true;
            }
            // 处理数据
            if (this.pageIndex === 1) {
              this.orderList = list;
            } else {
              this.orderList = this.orderList.concat(list);
            }
            this.pageIndex++;
          } else {
            this.error = true;
          }
          this.isUpLoading = false;
        })
        .catch((res) => {
          this.error = true;
          this.isUpLoading = false;
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/beSettledRule") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      // 重置数据
      Object.assign(this.$data, this.$options.data.call(this));
    }
    this.$route.meta.isBack = false;
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: calc(100vh - 44px);
  .settle {
    top: 44px;
  }
}
.cover {
  height: 100%;
  .settle {
    top: 0;
  }
}
.settle {
  position: fixed;
  left: 0;
  width: 345px;
  height: 50px;
  padding: 0 15px;
  font-size: 15px;
  background-color: #ffffff;
  .settle-price {
    font-size: 17px;
    font-weight: 800;
  }
}
.order-box {
  padding-top: 50px;
}
.order-info {
  margin: 10px 10px 0;
  padding: 10px 10px 0;
  border-radius: 10px;
  background-color: #ffffff;
  .info-common {
    font-size: 15px;
    padding-bottom: 10px;
  }
}
.notHave {
  margin-top: 178px;
  text-align: center;
  i {
    font-size: 107px;
    color: #d5d5d7;
  }
  p {
    font-size: 15px;
    color: #a3a2a2;
    margin-top: 32px;
  }
}
</style>